import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { deviceStatusConverter } from 'utils/patientDeviceStatus';
import { ReadingTypes } from 'constants/readingTypes';

const PatientDevices = ({ devices }) => (
  <div className="table-container" style={{ textAlign: 'center' }}>
    <Table
      className="small-table"
      borderless
      border="0"
      cellSpacing="0"
      cellPadding="0"
    >
      <colgroup>
        <col style={{ width: '30%' }} />
        <col style={{ width: '35%' }} />
        <col style={{ width: '10%' }} />
        <col style={{ width: '25%' }} />
      </colgroup>
      <thead>
        <tr>
          <th>Devices</th>
          <th>Reading Type</th>
          <th>Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {devices.map((device) => (
          <tr key={device.deviceId} style={{ textAlign: 'left' }}>
            <td>
              <span>{device.manufacturer}</span>
              <span style={{ wordBreak: 'break-word' }}>{device.deviceId}</span>
            </td>
            <td className="index" style={{ textAlign: 'left' }}>
              {device.readingTypes.map((d) => (
                <p style={{ margin: '0px' }}>{ReadingTypes[d]}</p>
              ))}
            </td>
            <td>{deviceStatusConverter(device.isActive)}</td>
            <td style={{ whiteSpace: 'initial' }}>{device.statusUpdatedAt}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);
PatientDevices.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.shape()),
};

export default PatientDevices;
